import { Fragment, useState } from "react";
import { Modal, Badge, Image, Skeleton, Text, Button } from "@mantine/core";
import {
  HiIdentification,
  HiHashtag,
  HiOfficeBuilding,
  HiAcademicCap,
  HiCollection,
  HiLocationMarker,
  HiUser,
} from "react-icons/hi";
import { EPlaceholder } from "../../../../libs/ui/src/Placeholder/EPlaceholder";
import { ECard } from "../../../../libs/ui/src/Card/ECard";
import { EButton, ESectionDivider, ETable } from "../../../../libs/ui";

const SchoolProfileDetail = ({
  schoolDataHit,
  isLoadingSchoolVisit,
  data,
  image,
  visitData,
  visitDataHit,
  isLoadingVisit,
}) => {
  const basic = data || {};
  const isEmpty = !data || Object.keys(data).length === 0;

  const [opened, setOpened] = useState(false);
  const [selectedObservation, setSelectedObservation] = useState([]);
  return (
    <>
      {!schoolDataHit ? (
        <>
          <EPlaceholder
            iconSrc={
              require("../../../../assets/icons/icon-placeholder.svg").default
            }
            title=""
            description="Please enter a school code to view details."
          />
        </>
      ) : isEmpty ? (
        <>
          <EPlaceholder
            iconSrc={
              require("../../../../assets/icons/icon-placeholder.svg").default
            }
            title="No Data Found"
            description="No records match your Entered School Code."
          />
        </>
      ) : (
        <Fragment>
          <div className="bg-gradient-to-r from-blue-800 to-blue-600 rounded-lg p-6 flex flex-wrap gap-6 text-white mt-10">
            <div className="flex-shrink-0 w-28 h-28 rounded-md overflow-hidden">
              <Image
                width={200}
                height={100}
                src={image}
                className="object-cover w-full h-full"
              />
            </div>

            <div className="flex-1 min-w-[300px]">
              <h2 className="font-semibold text-white text-lg mb-4">
                {basic?.schoolName || "--"}
              </h2>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-y-4 gap-x-6">
                <div className="flex items-center text-white text-sm">
                  <HiIdentification className="w-5 h-5 text-white opacity-80 mr-2" />
                  <span className="opacity-80">UDISE Code:</span>
                  <span className="font-semibold ml-1">
                    {basic?.udiseCode || "--"}
                  </span>
                </div>

                <div className="flex items-center text-white text-sm">
                  <HiHashtag className="w-5 h-5 text-white opacity-80 mr-2" />
                  <span className="opacity-80">School Code:</span>
                  <span className="font-semibold ml-1">
                    {basic?.schoolCode || "--"}
                  </span>
                </div>

                {/* <div className="flex items-center text-white text-sm">
              <HiOfficeBuilding className="w-5 h-5 text-white opacity-80 mr-2" />
              <span className="opacity-80">School Ownership:</span>
              <span className="font-semibold ml-1">
                {basic?.schoolOwner || '--'}
              </span>
            </div> */}

                {/* <div className="flex items-center text-white text-sm">
              <HiAcademicCap className="w-5 h-5 text-white opacity-80 mr-2" />
              <span className="opacity-80">School Type:</span>
              <span className="font-semibold ml-1">
                {basic?.schoolType || '--'}
              </span>
            </div> */}

                {/* <div className="flex items-center text-white text-sm">
              <HiCollection className="w-5 h-5 text-white opacity-80 mr-2" />
              <span className="opacity-80">School Category:</span>
              <span className="font-semibold ml-1">
                {basic?.schoolCategory || '--'}
              </span>
            </div> */}

                <div className="flex items-center text-white text-sm">
                  <HiLocationMarker className="w-5 h-5 text-white opacity-80 mr-2" />
                  <span className="opacity-80">District:</span>
                  <span className="font-semibold ml-1">
                    {basic?.districtName || "--"}
                  </span>
                </div>

                <div className="flex items-center text-white text-sm">
                  <HiLocationMarker className="w-5 h-5 text-white opacity-80 mr-2" />
                  <span className="opacity-80">Block:</span>
                  <span className="font-semibold ml-1">
                    {basic?.blockName || "--"}
                  </span>
                </div>

                <div className="flex items-center text-white text-sm">
                  <HiLocationMarker className="w-5 h-5 text-white opacity-80 mr-2" />
                  <span className="opacity-80">Cluster:</span>
                  <span className="font-semibold ml-1">
                    {basic?.clusterName || "--"}
                  </span>
                </div>
                <div className="flex items-center text-white text-sm">
                  <HiUser className="w-5 h-5 text-white opacity-80 mr-2" />
                  <span className="opacity-80">Total Students:</span>
                  <span className="font-semibold ml-1">
                    {basic?.totalSchoolStudentCount || "--"}
                  </span>
                </div>

                {/* <div className="flex items-center text-white text-sm">
              <HiLocationMarker className="w-5 h-5 text-white opacity-80 mr-2" />
              <span className="opacity-80">Adopted By:</span>
              <span className="font-semibold ml-1">
                {`${data?.LEGAL_FULL_NAME || '---'} [${
                  data?.employeeCode || '---'
                }] | ${data?.JOB_POST_NAME || '---'}` || '--'}
              </span>
            </div> */}

                {/* <div className="flex items-center text-white text-sm">
              <HiLocationMarker className="w-5 h-5 text-white opacity-80 mr-2" />
              <span className="opacity-80">Contact Number:</span>
              <span className="font-semibold ml-1">
                {data?.PHONE_NUMBER || '--'}
              </span>
            </div> */}
              </div>
            </div>
          </div>

          <div className="mt-4">
            <ECard title="Teachers Details" customClass="overflow-auto">
              {!isLoadingSchoolVisit ? (
                <>
                  {basic?.teachers?.length > 0 ? (
                    <>
                      <ETable>
                        <thead>
                          <tr>
                            <th>S No.</th>
                            <th>Teacher Name</th>
                            <th>Teacher Code</th>
                            <th>Designation</th>
                          </tr>
                        </thead>
                        <tbody>
                          {basic?.teachers?.map((item, index) => {
                            return (
                              <tr>
                                <td>{index + 1}</td>
                                <td>{item?.teacherName}</td>
                                <td>{item?.teacherCode}</td>
                                <td>{item?.teacherType}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </ETable>
                    </>
                  ) : (
                    <div className="text-blue-600 text-sm mt-2 mb-2 text-center">
                      <Text fz="md">No record Found!</Text>
                    </div>
                  )}
                </>
              ) : (
                <Skeleton height={220} radius="md" />
              )}
            </ECard>
          </div>

          <div className="mt-4">
            <ECard title="Visit Details" customClass="overflow-auto">
              {!isLoadingVisit ? (
                <>
                  {visitData?.length > 0 ? (
                    <>
                      <ETable>
                        <thead>
                          <tr>
                            <th>S No.</th>
                            <th>Mentor Name</th>
                            <th>Designation</th>
                            <th>Visited Date</th>
                            <th>Total Class Visited</th>
                            <th>Teachers</th>
                            <th>Class Observation Details</th>
                            <th>Total Student Accessed</th>
                            <th>Total Visit Completed</th>
                          </tr>
                        </thead>
                        <tbody>
                          {visitData?.map((item, index) => {
                            return (
                              <tr>
                                <td>{index + 1}</td>
                                <td>{item?.mentor_Name}</td>
                                <td>{item?.designation}</td>
                                <td>{item?.date_Visited}</td>
                                <td>{item?.total_Class_Visited}</td>
                                <td>
                                  {item?.teachers ? (
                                    <div className="flex flex-wrap gap-2">
                                      {item.teachers
                                        .split(",")
                                        .map((teacher, i) => (
                                          <Badge
                                            key={i}
                                            color="blue"
                                            variant="light"
                                          >
                                            {teacher.trim()}
                                          </Badge>
                                        ))}
                                    </div>
                                  ) : (
                                    <span className="text-gray-400">--</span>
                                  )}
                                </td>
                                <td>
                                  <EButton
                                    className="btn-blue"
                                    size="xs"
                                    onClick={() => {
                                      setSelectedObservation(
                                        item?.class_Observation_Details || [],
                                      );
                                      setOpened(true);
                                    }}
                                  >
                                    View
                                  </EButton>
                                </td>
                                <td>{item?.total_Student_Accessed}</td>
                                <td>{item?.visits_Completed_Total}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </ETable>
                    </>
                  ) : (
                    <div className="text-blue-600 text-sm mt-2 mb-2 text-center">
                      <Text fz="md">No record Found!</Text>
                    </div>
                  )}
                </>
              ) : (
                <Skeleton height={220} radius="md" />
              )}
            </ECard>
          </div>
        </Fragment>
      )}

      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        title="Class Observations"
        size="lg"
      >
        {selectedObservation.length > 0 ? (
          <div className="space-y-3">
            {selectedObservation.map((obs, index) => (
              <div key={index} className="p-3 border rounded-lg">
                <div className="font-medium">{obs.class_Name}</div>

                <Badge color="green" variant="light">
                  {obs.observation_Feedback}
                </Badge>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-400">No Observations</p>
        )}
      </Modal>
    </>
  );
};

export default SchoolProfileDetail;
